module.exports = __webpack_public_path__ + "static/key-generationzero-0dfc53db0f2ebe94b1555e8c02ad0b38.webp";